module.exports = {"230726100":"南岔镇","230726101":"晨明镇","230726102":"浩良河镇","230726200":"迎春乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230726.json
// module id = 852
// module chunks = 0